import { useState } from 'react';
import { baseInputClass } from '../constants';

type NumberQuestionType = any;

interface NumberQuestionInputProps {
  disabled: boolean;
  type: NumberQuestionType;
}

export const NumberQuestionInput = ({ disabled, type }: NumberQuestionInputProps) => {
  const [value, setValue] = useState<string>('');

  const isDecimal = type === 'decimal_q';
  const isCounter = type === 'counter_q';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value;

    if (isDecimal) {
      // Allow only one decimal point
      val = val.replace(/[^0-9.]/g, '');
      const parts = val.split('.');
      if (parts.length > 2) {
        val = parts[0] + '.' + parts[1];
      }
    } else {
      // Integer only
      val = val.replace(/\D/g, '');
    }

    setValue(val);
  };

  const increment = () => {
    if (disabled) return;
    const num = parseFloat(value || '0');
    setValue(String(isDecimal ? num + 1 : Math.floor(num + 1)));
  };

  const decrement = () => {
    if (disabled) return;
    const num = parseFloat(value || '0');
    const newValue = Math.max(0, isDecimal ? num - 1 : Math.floor(num - 1));
    setValue(String(newValue));
  };

  return (
    <div className="space-y-2">
      <div className="relative flex items-center">
        {isCounter ? (
          <input
            type="number"
            value={value}
            onChange={handleChange}
            placeholder={type === 'decimal_q' ? 'Enter decimal number' : 'Enter number'}
            className={baseInputClass}
            disabled={disabled}
          />
        ) : (
          <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder={type === 'decimal_q' ? 'Enter decimal number' : 'Enter number'}
            className={`${baseInputClass} ${isCounter ? 'pr-16' : ''}`}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
};
